import {
  SnotifyPosition,
  SnotifyStyle
} from 'vue-snotify'

const state = {
  type: null,
  notifyType: null,
  message: null,
  time: 0,
  data: {}
};

const actions = {
  default ({
    commit
  }, message) {
    commit('default', message);
  },
  success({
    commit
  }, message) {
    commit('success', message);
  },
  error({
    commit
  }, message) {
    commit('error', message);
  },
  clear({
    commit
  }, message) {
    commit('success', message);
  }
};

const mutations = {
  default (state, message) {
    state.time = new Date();
    state.type = 'alert-default';
    state.notifyType = SnotifyStyle.info;
    state.message = message;
    state.data = {};
  },
  success(state, message) {
    state.time = new Date();
    state.notifyType = SnotifyStyle.success;
    state.type = 'alert-success';
    state.message = message;
    state.data = {};
  },
  warning (state, message) {
    state.time = new Date();
    state.type = 'alert-info';
    state.notifyType = SnotifyStyle.warning;
    state.message = message;
    state.data = {};
  },
  error(state, message) {
    console.log(message)
    const data = message.data;
    let errores = "";
    if (data.message === "Validation Error.") {
      if (data.hasOwnProperty('data')) {
        errores = data.data
      }

    }
    console.log(data)

    state.time = new Date();
    state.notifyType = SnotifyStyle.error;
    state.type = 'alert-danger';

    if (message && message.hasOwnProperty('data')) {

     /*  let errores = "";
      if (message.hasOwnProperty('errors')) {
        errores = message.errors.join('<br/>');

      } */
      state.message = message.data;
      state.data = message.data;
    } else {
      state.data = {};
      state.message = message.text;
    }

  },
  clear(state) {
    state.type = null;
    state.message = null;
  }
};

export const alert = {
  namespaced: true,
  state,
  actions,
  mutations
};
